import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClockComponent } from './clock.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from 'app/services/custom-translate-loader';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { DataService, HTTPService } from 'app/services';

@NgModule({
  imports: [CommonModule, TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useClass: CustomTranslateLoader,
      deps: [HttpClient, CookieService, DataService, HTTPService]
    }
  })],
  declarations: [ClockComponent],
  exports: [ClockComponent],
})
export class AppClockModule { }
